// extracted by mini-css-extract-plugin
export default {"root":"udGhe8vjWv3i5p9em4IO","badgeContainer":"p5WW0llA8_79Qb9MrVPj","title":"jkhAEU2wgtuCOce3OXir","badgeItem":"LzBtExlfBV9hBI15Oj9G","placeholderAnimate":"i5Yc0bkkjzUOUbJKNG57"};